export const demandTypes = [
    {
        name: "课程推广",
        value: 'enroll',
    },
    {
        name: "活动策划",
        value: 'plan',
    }
]

export const demandStatus = [
    {
        name: "待支付",
        value: 1,
    }, {
        name: "待审核",
        value: 2,
    },
    {
        name: "通过",
        value: 3,
    }, {
        name: "拒绝",
        value: 4,
    }, {
        name: "上架中",
        value: 5,
    }, {
        name: "下架",
        value: 6,
    }, {
        name: "结束",
        value: 7,
    }, {
        name: "取消",
        value: 8,
    }
]


//擅长推广人群
export const userPersonTypes = [{
	name: '公域(各种人群)',
	value: '公域'
}, {
	name: '社群用户',
	value: '社群用户'
}, {
	name: '青少年',
	value: '青少年'
}, {
	name: '企业资源',
	value: '企业资源'
}, {
	name: '中老年',
	value: '中老年'
}, {
	name: '大学生',
	value: '大学生'
}, {
	name: '上班族',
	value: '上班族'
}]


//主理人身份
export const enrollUserTypes = [{
	name: '宝妈团长',
	value: '宝妈团长'
}, {
	name: '学校老师',
	value: '学校老师'
}, {
	name: '学科教研员',
	value: '学科教研员'
}, {
	name: '招生主管',
	value: '招生主管'
}, {
	name: '机构老板',
	value: '机构老板'
}, {
	name: '社区达人',
	value: '社区达人'
}, {
	name: '教培博主',
	value: '教培博主'
},{
	name: '个人',
	value: '个人'
}]
